import React, { useEffect, useState } from 'react'
import styles from './UsageGauge.module.css'
import useCountUp from './useCountUp'

// Gole ka kitna hissa arc ho — 60% (216°), aadhe se thoda zyada. Khaali
// hissa neeche beech me rehta hai.
const SWEEP_DEG = 216

/**
 * Animated usage gauge — 60% ka arc, upar se hokar, gap neeche.
 * `used` / `total` drive the purple arc; the minutes value counts up.
 */
const UsageGauge = ({ used = 0, total = null }) => {
  const width = 120
  const stroke = 9
  const r = (width - stroke) / 2
  const cx = width / 2
  const cy = r + stroke / 2

  // Dono sire upar (-90°) se SWEEP/2 door, baayein aur daayein.
  const half = ((SWEEP_DEG / 2) * Math.PI) / 180
  const dx = r * Math.sin(half)
  const dy = -r * Math.cos(half) // half > 90° → positive, center se neeche
  // Box arc ke neeche wale sire tak (+ round cap ki aadhi motai).
  const height = cy + dy + stroke / 2

  // Left sira → upar se ghoom ke → right sira. 180° se bada, isliye large-arc=1.
  const arc = `M ${cx - dx} ${cy + dy} A ${r} ${r} 0 1 1 ${cx + dx} ${cy + dy}`
  // pathLength=100 → dash values seedhe percent me.
  const LEN = 100

  // No cap on PAYG → no total. Show a partial arc based on used minutes so the
  // gauge still animates, without implying a fixed limit.
  const pct = Math.max(0, Math.min(1, total ? used / total : Math.min(used / 100, 1)))

  // Animate the filled portion via dashoffset (start empty → fill on mount).
  const [offset, setOffset] = useState(LEN)
  useEffect(() => {
    const id = requestAnimationFrame(() => setOffset(LEN - pct * LEN))
    return () => cancelAnimationFrame(id)
  }, [pct])

  const minutes = useCountUp(used, { duration: 1200 })

  return (
    <div className={styles.gauge} style={{ width, height }}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={styles.svg}>
        {/* track */}
        <path
          d={arc}
          fill="none"
          stroke="#D5C7F9"
          strokeWidth={stroke}
          strokeLinecap="round"
        />
        {/* progress — ONLY drawn when there's real usage. At 0 usage the path
            is not rendered at all, so the gauge is completely empty (just the
            light track). A round linecap otherwise draws a dot even at 0 length,
            which is the stray mark we're removing. The purple dot/arc appears
            the moment usage > 0, exactly as before. */}
        {pct > 0 && (
          <path
            d={arc}
            fill="none"
            stroke="#6524EB"
            strokeWidth={stroke}
            strokeLinecap="round"
            pathLength={LEN}
            strokeDasharray={LEN}
            strokeDashoffset={offset}
            className={styles.progress}
          />
        )}
      </svg>
      {/* Text gole ke center (cy) pe — box ke beech me nahi, wo neeche khisak
          jaata kyunki box gap tak hi jaata hai. */}
      <div className={styles.center} style={{ height: 2 * cy }}>
        <span className={styles.value}>{Math.round(minutes)}</span>
        <span className={styles.label}>Minutes Used</span>
        {total != null && <span className={styles.sub}>of {total} min</span>}
      </div>
    </div>
  )
}

export default UsageGauge
